'use strict';

var jsxRuntime = require('@emotion/react/jsx-runtime');
var react = require('@emotion/react');
var index = require('../../../aviary-core/dist/cjs/index.cjs');

/**
 * SVG Illustration of announcement
 */ const Announcement = ({ assetColor = index.ASSET_COLORS.grey, size = index.ILLUSTRATION_DIMENSIONS.medium, ...rest })=>{
    const theme = react.useTheme();
    return /*#__PURE__*/ jsxRuntime.jsxs("svg", {
        width: size,
        height: size,
        viewBox: "0 0 104 104",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg",
        ...rest,
        children: [
            /*#__PURE__*/ jsxRuntime.jsx("circle", {
                cx: "52",
                cy: "52",
                r: "52",
                fill: theme.ds5.asset[assetColor].background
            }),
            /*#__PURE__*/ jsxRuntime.jsx("path", {
                d: "M63.7918 28.0001C63.4005 28.0001 63.0187 28.1333 62.6971 28.3808C59.2726 31.0123 55.1139 33.7183 50.1731 36.1099C39.8104 41.1262 30.3254 42.6707 24.1929 43.1687V58.2547C30.3254 58.7527 39.8104 60.2972 50.1731 65.3135C55.1139 67.7051 59.2726 70.4114 62.6971 73.0426C63.019 73.2898 63.4005 73.4233 63.7918 73.4233C64.8509 73.4233 65.7093 72.4717 65.7093 71.2975V30.1256C65.7093 28.9517 64.8509 28.0001 63.7918 28.0001Z",
                fill: theme.ds5.asset[assetColor]["100"]
            }),
            /*#__PURE__*/ jsxRuntime.jsx("path", {
                d: "M88 50.4831C88 54.1744 87.2996 57.7734 85.918 61.1801C84.4872 64.7084 82.3862 67.8729 79.673 70.586C79.6635 70.5956 79.6543 70.6048 79.6448 70.6143C78.9236 71.3335 77.7543 71.3283 77.034 70.608L76.1963 69.7703C75.4711 69.045 75.4771 67.8714 76.2029 67.1468C76.2081 67.1416 76.213 67.1367 76.2182 67.1315C85.3981 57.9516 85.3981 43.0146 76.2182 33.8347C76.2064 33.8229 76.1946 33.8111 76.1825 33.7989C75.4558 33.0752 75.4503 31.901 76.1755 31.1757L77.0132 30.3381C77.7335 29.6177 78.902 29.6131 79.624 30.3317C79.6402 30.3479 79.6563 30.364 79.6725 30.3802C82.3856 33.0933 84.4866 36.2578 85.9174 39.7861C87.299 43.1928 88 46.7918 88 50.4831ZM79.3031 50.4831C79.3031 47.9213 78.8169 45.4236 77.8581 43.0587C76.865 40.6094 75.4065 38.4127 73.5235 36.5297C73.5071 36.5133 73.4906 36.4968 73.4742 36.4804C72.7518 35.763 71.584 35.7676 70.8643 36.4876L70.0266 37.3253C69.3008 38.0511 69.3071 39.2267 70.0352 39.9502C70.0465 39.9615 70.0577 39.9727 70.0692 39.984C75.8581 45.773 75.8581 55.1923 70.0692 60.9811C70.0646 60.9857 70.0603 60.99 70.0557 60.9946C69.3287 61.7196 69.3212 62.8938 70.047 63.6199L70.8847 64.4575C71.6048 65.1776 72.7735 65.1831 73.4947 64.4645C73.5042 64.455 73.514 64.4451 73.5235 64.4356C75.4065 62.5526 76.8647 60.3559 77.8581 57.9066C78.8169 55.5421 79.3031 53.044 79.3031 50.4822V50.4831ZM65.6167 43.8506V57.0957C68.036 55.8748 69.6952 53.3681 69.6952 50.4733C69.6952 47.5785 68.036 45.0712 65.6167 43.8506Z",
                fill: theme.ds5.asset[assetColor]["500"]
            }),
            /*#__PURE__*/ jsxRuntime.jsx("path", {
                d: "M34.1356 59.4529C31.5193 58.9324 28.8647 58.557 26.1792 58.3271L27.7859 73.7659C27.976 75.5918 29.6626 76.8825 31.4746 76.5883L34.37 76.1183C36.1824 75.8242 37.3742 74.0666 36.9768 72.2742L34.1356 59.4529Z",
                fill: theme.ds5.asset[assetColor]["100"]
            }),
            /*#__PURE__*/ jsxRuntime.jsx("path", {
                d: "M15 45.4166V55.8252C15 57.1168 16.047 58.1638 17.3386 58.1638H24.325V43.0778H17.3386C16.047 43.0778 15 44.1251 15 45.4166Z",
                fill: theme.ds5.asset[assetColor]["500"]
            })
        ]
    });
};

exports.Announcement = Announcement;
//# sourceMappingURL=Announcement.cjs.map
